<template>
  <e-autocomplete
    v-model="value"
    :items="townSuggestions"
    :loading="isLoadingTownSuggestions"
    label="Город"
    show-menu-icon
    @update:search="getTownSuggestions"
  />
</template>

<script setup lang="ts">
import { EAutocomplete } from '@/core/components/ui';
import { useSuggestions } from '@/core/composables/suggestions';

const value = defineModel<string | null>({ required: true });

const { useTownSuggestions } = useSuggestions();

const {
  isLoading: isLoadingTownSuggestions,
  suggestions: townSuggestions,
  getSuggestions: getTownSuggestions,
} = useTownSuggestions();
</script>

<style scoped lang="scss"></style>
